import React from 'react';
import { Typography } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import BundlesPanel from './BundlesPanel';
import '../dashboard/Dashboard.css';

const { Title, Text } = Typography;

// Global bundle catalog (bundle → features). Company licenses and per-user
// access live on the /companies page; this screen curates the shared bundles.
const Bundles = () => (
    <div className="gh-users-page">
        <div className="gh-users-filter-bar" style={{ justifyContent: 'space-between' }}>
            <Title level={4} style={{ margin: 0, whiteSpace: 'nowrap' }}>
                <AppstoreOutlined style={{ marginRight: 8 }} />
                Bundles
            </Title>
            <Text type="secondary" style={{ fontSize: 12 }}>
                Bundles are shared across all companies — assign them to users via a company’s Licenses on the Companies page.
            </Text>
        </div>
        <BundlesPanel />
    </div>
);

export default Bundles;
